// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"avatarWrapper--xLyPe","settingsIcon":"settingsIcon--fzy1w"};